// extracted by mini-css-extract-plugin
export var ellipsesOverflow = "_dx-a";
export var fulfillmentFormRail = "_dx-9";
export var headerTitleRow = "_dx-c";
export var orderDetailsWrapper = "_dx-7";
export var orderLinkTrigger = "_dx-2";
export var paymentInformationGrid = "_dx-h";
export var paymentSummaryColumn = "_dx-i";
export var shipmentContainer = "_dx-b";
export var shipmentDetailsMainPane = "_dx-8";
export var shipmentNavigationCard = "_dx-5";
export var shipmentNavigationRail = "_dx-3";
export var shipmentNavigationRailHeader = "_dx-4";
export var shipmentSummaryFact = "_dx-e";
export var shipmentSummaryGrid = "_dx-d";
export var shipmentSummaryMetadataRow = "_dx-f";
export var shipmentSummaryTags = "_dx-g";
export var shipmentWorkspace = "_dx-0";
export var shipmentWorkspaceContent = "_dx-6";
export var shipmentWorkspaceHeader = "_dx-1";